import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clickInvoiceRow(event) {
    // Don't trigger navigation if clicking on custom field cells, action buttons, or checkboxes
    if (event.target.closest('[data-invoice-row-no-navigation]') ||
        event.target.closest('[data-action*="modal#open"]') ||
        event.target.closest('button') ||
        event.target.closest('input[type="checkbox"]') ||
        event.target.closest('a')) {
      return
    }

    const url = this.element.dataset.invoiceUrl
    if (url) {
      window.location.href = url
    }
  }
}
